import { render, staticRenderFns } from "./LinuxIcon.vue?vue&type=template&id=5724da16&scoped=true"
import script from "./LinuxIcon.vue?vue&type=script&lang=js"
export * from "./LinuxIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5724da16",
  null
  
)

export default component.exports